import type { IFieldOptions } from '@axo/form/feature/form-input/types';
import type { IOption } from '@axo/shared/ui/input/lib/RadioGroup/RadioGroupUI';
import { generateAmountOptions } from '../../../../../../utils/generateOptions';
import { MAX_LOAN_AMOUNT, MIN_LOAN_AMOUNT } from '../../../config/globals';

export const appliedAmountFieldOptions = {
  options: generateAmountOptions({
    lowerLimit: MIN_LOAN_AMOUNT,
    upperLimit: MAX_LOAN_AMOUNT,
    step: 5_000,
    suffix: 'kr',
  }),
  registerOptions: {
    valueAsNumber: true,
    required: 'error.required',
  },
} satisfies IFieldOptions & { options: IOption[] };
